interface GradientWarningIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const GradientWarningIcon: React.FC<GradientWarningIconProps> = ({
  width = 23,
  height = 22,
  className = ''
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 23 22"
      fill="none"
      className={className}
      aria-label="Gradient Attention Icon"
      role="img"
    >
      <path
        d="M11.4919 2.75C12.6204 2.75 13.6831 2.9664 14.6797 3.39901C15.6815 3.82631 16.5593 4.41991 17.3133 5.17952C18.0727 5.93924 18.6686 6.81782 19.101 7.81494C19.5334 8.80678 19.75 9.86741 19.75 10.9964C19.75 12.1306 19.5334 13.1961 19.101 14.1931C18.6686 15.1849 18.0726 16.0608 17.3133 16.8205C16.5593 17.5801 15.6843 18.1737 14.6877 18.601C13.6911 19.0336 12.6285 19.25 11.5 19.25C10.3715 19.25 9.3089 19.0336 8.31226 18.601C7.31571 18.1737 6.43793 17.5801 5.67863 16.8205C4.91929 16.0608 4.32336 15.1849 3.89095 14.1931C3.46386 13.1961 3.25005 12.1306 3.25 10.9964C3.25 9.86743 3.46384 8.80677 3.89095 7.81494C4.32336 6.81782 4.9165 5.93924 5.67057 5.17952C6.42985 4.4199 7.30767 3.82633 8.3042 3.39901C9.3008 2.96641 10.3635 2.75002 11.4919 2.75ZM11.5 13.75C10.7406 13.75 10.125 14.3656 10.125 15.125C10.125 15.8844 10.7406 16.5 11.5 16.5C12.2594 16.5 12.875 15.8844 12.875 15.125C12.875 14.3656 12.2594 13.75 11.5 13.75ZM11.1007 5.5C10.572 5.5 10.1529 5.94624 10.1859 6.47396L10.5296 11.974C10.5599 12.457 10.9605 12.8333 11.4445 12.8333H11.5555C12.0395 12.8333 12.4401 12.457 12.4704 11.974L12.8141 6.47396C12.8471 5.94624 12.428 5.5 11.8993 5.5H11.1007Z"
        fill="url(#paint0_linear_6576_7389)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6576_7389"
          x1="3.25"
          y1="2.75"
          x2="19.8845"
          y2="2.88674"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF45A9" />
          <stop offset="1" stopColor="#FF6A6A" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GradientWarningIcon;
